import { actions } from '../actions';

const initialState = {
  stats: {},
  computedStats: {},
  items: [],
  snapshots: {
    stats: {},
    items: []
  }
};

const branchReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_BRANCHES_STATS_SUCCEED:
      return {
        ...state,
        stats: action.payload
      };
    case actions.GET_BRANCHES_STATS_FAILURE:
      return {
        ...state,
        stats: {}
      };

    case actions.GET_BRANCHES_SNAPSHOTS_SUCCEED:
      return {
        ...state,
        snapshots: {
          ...state.snapshots,
          items: action.payload
        }
      };
    case actions.GET_BRANCHES_SNAPSHOTS_FAILURE:
      return {
        ...state,
        snapshots: {
          ...state.snapshots,
          items: []
        }
      };

    case actions.GET_BRANCHES_SNAPSHOTS_STATS_SUCCEED:
      return {
        ...state,
        snapshots: {
          ...state.snapshots,
          stats: action.payload
        }
      };
    case actions.GET_BRANCHES_SNAPSHOTS_STATS_FAILURE:
      return {
        ...state,
        snapshots: {
          ...state.snapshots,
          stats: {}
        }
      };

    default:
      return state;
  }
};

export default branchReducer;
